// services/simpleExportService.js
 import api from '../connection/api';

class SimpleExportService {
  // هەموو داتاکان
  async exportAll() {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/export/simple/all', {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, 'هەموو-داتاکان.xlsx');
    } catch (error) {
      throw new Error('پەرستەکردنی هەموو داتاکان سەرنەکەوت');
    }
  }

  // تەنها هاتوو
  async exportHatorOnly() {
    try {
      const token = localStorage.getItem('token');

      const response = await api.get('/export/simple/hator-only', {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, 'تەنها-هاتوو.xlsx');
    } catch (error) {
      throw new Error('پەرستەکردنی هاتووەکان سەرنەکەوت');
    }
  }

  // تەنها نەهاتوو
  async exportNotHatorOnly() {
    try {
      const token = localStorage.getItem('token');

      const response = await api.get('/export/simple/not-hator-only', {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, 'تەنها-نەهاتوو.xlsx');
    } catch (error) {
      throw new Error('پەرستەکردنی نەهاتووەکان سەرنەکەوت');
    }
  }

  // بەپێی بنکە - هەموو داتا
  async exportByBase(base) {
    try {
      const token = localStorage.getItem('token');

      const response = await api.post('/export/simple/by-base', { base }, {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, `بنکە-${base}.xlsx`);
    } catch (error) {
      throw new Error(`پەرستەکردنی بنکەی ${base} سەرنەکەوت`);
    }
  }

  // بەپێی بنکە - تەنها هاتوو
  async exportHatorByBase(base) {
    try {
      const token = localStorage.getItem('token');

      const response = await api.post('/export/simple/hator-by-base', { base }, {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, `بنکە-${base}-هاتوو.xlsx`);
    } catch (error) {
      throw new Error(`پەرستەکردنی هاتووەکانی بنکەی ${base} سەرنەکەوت`);
    }
  }

  // بەپێی بنکە - تەنها نەهاتوو
  async exportNotHatorByBase(base) {
    try {
      const token = localStorage.getItem('token');

      const response = await api.post('/export/simple/not-hator-by-base', { base }, {
        responseType: 'blob', headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return this.handleDownload(response, `بنکە-${base}-نەهاتوو.xlsx`);
    } catch (error) {
      throw new Error(`پەرستەکردنی نەهاتووەکانی بنکەی ${base} سەرنەکەوت`);
    }
  }

  // کۆی ئامار
  async getStatistics() {
    try {
      const token = localStorage.getItem('token');

      const response = await api.get('/export/simple/statistics', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('هێنانی ئامارەکان سەرنەکەوت');
    }
  }

  // لیستی بنکەکان
  async getBases() {
    try {
      const response = await api.get('/export/simple/bases');
      return response.data.bases;
    } catch (error) {
      throw new Error('هێنانی لیستی بنکەکان سەرنەکەوت');
    }
  }

  handleDownload(response, defaultFilename) {
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    const contentDisposition = response.headers['content-disposition'];
    let filename = defaultFilename;
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURIComponent(filenameMatch[1]);
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, filename };
  }
}

export default new SimpleExportService();